import WeaTable from './components/Table';
import store from './stores/index';
import TableStore from './stores/table';

module.exports = {
  store,
  WeaTable,
  TableStore,
};



// WEBPACK FOOTER //
// ./comMobx/wea-table-new/index.js